__webpack_require__.p = "/partners-widgets/";